import React, { useEffect, useRef } from 'react';

import { useFormDataQuery } from '@/api/getters';
import { Stages } from '@/api/types';
import { useStepper } from '@/features/v2/lib/stepper';
import { FormComponent, Stepper } from '@/features/v2/lib/wizard';
import { PRODUCT_DATA } from '@/features/v2/product-data';
import ClientCardVD from '@/features/v2/vehicle-damage/components/layout/ClientCardVD';
import {
  getUserType,
  handleVehicleDamageStageView,
} from '@/helpers/addStageToDataLyer';
import cn from '@/utils/cn';

const VehicleDamage = () => {
  const { data } = useFormDataQuery();
  const { step, setStep } = useStepper();

  // Reports stage views / completions to the GTM dataLayer as the user moves
  // through the form (formularz_etap_widok / formularz_etap_zakonczenie).
  const previousStageRef = useRef<Stages | undefined>(undefined);
  useEffect(() => {
    if (!data?.stage) return;
    handleVehicleDamageStageView(
      data.stage,
      previousStageRef.current,
      !!data.offer?.is_complementary,
      getUserType(data)
    );
    previousStageRef.current = data.stage;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.stage]);

  // TODO: do it better (condition in order to accept the offer from mail)
  useEffect(() => {
    if (data?.stage === Stages.STAGE_I_DOCUMENTS && step === 0) {
      setStep(1);
    }
    if (
      (data?.stage === Stages.STAGE_IV ||
        data?.stage === Stages.STAGE_IV_COMPLEMENTARY) &&
      step < 4 &&
      data.offer.is_complementary
    ) {
      setStep(4);
    }
    if (
      (data?.stage === Stages.STAGE_IV ||
        data?.stage === Stages.STAGE_IV_COMPLEMENTARY) &&
      step < 5 &&
      !data.offer.is_complementary
    ) {
      setStep(5);
    }

    // in order to fix the bug with the step on the stage II finished
    if (data?.stage === Stages.STAGE_II_FINISHED && step < 3) {
      setStep(3);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.stage === Stages.STAGE_IV]);

  if (!data) return null;

  const StageComponent =
    PRODUCT_DATA[data.product.id].stages[data.stage].component;
  const progress = PRODUCT_DATA[data.product.id].stages[data.stage].progress;

  const displayProgressBar =
    progress &&
    !(
      data.stage === Stages.CONTACT_US &&
      (data?.offer?.offer_rejected === true ||
        data?.offer?.offer_rejected === false) &&
      !data.offer.is_complementary
    );

  return (
    <>
      <ClientCardVD
        className="hidden lg:flex"
        isOfferPage={
          data.stage === Stages.STAGE_III ||
          data.stage === Stages.STAGE_III_CONFLICT
        }
      />
      <div className={'w-full lg:flex lg:gap-x-5'}>
        <div
          className={cn(
            'flex flex-col lg:w-[670px] lg:gap-y-5',
            !displayProgressBar && 'lg:w-full'
          )}
        >
          {StageComponent ? StageComponent : <FormComponent />}
        </div>
        {displayProgressBar && (
          <div>
            <Stepper progressType={progress} />
          </div>
        )}
      </div>
    </>
  );
};

export default VehicleDamage;
